import { useEffect } from 'react';
import { TIMING_CONSTANTS } from '../constants/navigationConstants';

/**
 * Custom hook for managing auto-focus on flyout menu open
 * @param {boolean} isOpen - Whether the flyout is open
 * @param {boolean} shouldRefocus - Whether refocusing should happen
 * @param {React.RefObject} targetRef - Ref to the element to focus
 * @param {React.RefObject} triggerRef - Ref to the trigger element to check for keyboard activation
 * @param {number} delay - Delay before focusing (in ms). Default 50ms allows DOM updates to complete before focusing.
 */
export const useFlyoutAutoFocus = (isOpen, shouldRefocus, targetRef, triggerRef, delay = TIMING_CONSTANTS.FLYOUT_FOCUS_DELAY) => {
    useEffect(() => {
        if (!isOpen || !shouldRefocus || !targetRef.current) {
            return;
        }

        const timer = setTimeout(() => {
            // Check if the user is actually using keyboard navigation
            const isActivatedViaKeyboard = triggerRef?.current?.matches(':focus-visible');
            if (isActivatedViaKeyboard) {
                targetRef.current.focus();
            }
        }, delay);

        return () => clearTimeout(timer);
    }, [isOpen, shouldRefocus, targetRef, triggerRef, delay]);
};
